import { useCallback, useRef } from 'react';
import { BlockerFunction, useBlocker } from 'react-router-dom';

type ShouldBlock = boolean | BlockerFunction;

export default (shouldBlock: ShouldBlock) => {
  const allowNavigateRef = useRef(false);

  const wrappedShouldBlock = useCallback(
    (...args: Parameters<BlockerFunction>) => {
      if (allowNavigateRef.current) return false;
      return typeof shouldBlock === 'function' ? shouldBlock(...args) : shouldBlock;
    },
    [shouldBlock],
  );

  const blocker = useBlocker(wrappedShouldBlock);

  const allowNextNavigation = useCallback(() => {
    allowNavigateRef.current = true;
  }, []);

  const resetIfBlocked = useCallback(() => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  }, [blocker]);

  return [
    blocker,
    {
      allowNavigateRef,
      resetIfBlocked,
      allowNextNavigation,
    },
  ] as const;
};
